import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Section } from '../Section';
import { InfoBlock, InfoDate, InfoLabel, InfoName } from './styled';
export const InformationCard = memo(function InformationCard({ items }) {
    return (_jsx(Section, { children: items.map((item) => (_jsxs(InfoBlock, { "data-testid": item.dataTestId, children: [_jsx(InfoLabel, { children: item.label }), item.title && _jsx(InfoName, { children: item.title }), item.date && _jsx(InfoDate, { children: item.date })] }, item.label))) }));
});
